import { roleConfig } from '../constants/roleConfig';
import { useUser } from './useUser';

/**
 * 檢查當前用戶是否有足夠的角色等級
 * @param {number} requiredRole - 所需的最低角色等級（1=外包, 2=員工, 5=管理者）
 * @returns {boolean} - 用戶是否有足夠的權限
 */
export const useHasRole = (requiredRole) => {
  const { role } = useUser();
  
  if (!role) return false;
  
  // 用戶角色需要 >= requiredRole（例如管理者可以訪問員工級別的資源）
  return role >= requiredRole;
};

/**
 * 檢查當前用戶是否是特定角色
 * @param {number} roleValue - 角色值（1=外包, 2=員工, 5=管理者）
 * @returns {boolean} - 用戶是否是該角色
 */
export const useIsRole = (roleValue) => {
  const { role } = useUser();
  return role === roleValue;
};

/**
 * 獲取當前用戶的角色名稱
 * @returns {string} - 角色名稱
 */
export const useRoleName = () => {
  const { role } = useUser();
  const roleMap = Object.entries(roleConfig).map(([label, value]) => ({ label, value })).reduce((acc, { label, value }) => {
    acc[value] = label;
    return acc;
  }, {});
  return roleMap[role] || '未知';
};
